import { z } from 'zod';
import { Validation } from '@mews/framework';
import { createMewsTerminalPaymentFormSchema } from '../MewsTerminalPayment/schema';

export enum MewsTerminalPreauthorizationFormField {
    ExpirationUtc = 'expirationUtc',
}

export const createMewsTerminalPreauthorizationFormSchema = createMewsTerminalPaymentFormSchema.extend({
    [MewsTerminalPreauthorizationFormField.ExpirationUtc]: Validation.DateTime.Utc,
});

export type MewsTerminalPreauthorizationFormValues = z.infer<typeof createMewsTerminalPreauthorizationFormSchema>;
